import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import Tabs from '../views/Tabs.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/tabs/Visit'
  },
  {
    path: '/tabs/',
    component: Tabs,
    children: [
      {
        path: '',
        redirect: '/tabs/Visit'
      },
      {
        path: 'Visit',
        component: () => import('@/views/VisitTab.vue')
      },
      {
        path: 'Watch',
        component: () => import('@/views/WatchTab.vue')
      },
      {
        path: 'Read',
        component: () => import('@/views/ReadTab.vue')
      },
      {
        path: 'TheGospel',
        component: () => import('@/views/TheGospelTab.vue')
      },
      {
        path: '/Login',
        component: () => import('@/views/LoginPage.vue')
      }
    ]
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
